export default __webpack_public_path__ + "static/media/0x0d6ae2a429df13e44a07cd2969e085e4833f64a0.6906461d.webp";